export default function useComponentConfig() {
  const variants = {
    CURRENT: 'current',
    ERROR: 'error',
    INFO: 'info',
    WARNING: 'warning',
    SUCCESS: 'success'
  };

  const colors = {
    CURRENT: 'current',
    BLUE: 'blue',
    GREEN: 'green',
    GRAY: 'gray',
    WHITE: 'white',
    RED: 'red',
    YELLOW: 'yellow',
    TRANSPARENT: 'transparent',
    ORANGE: 'orange'
  };

  const sizes = {
    BLOCK: 'block',
    XS: 'xs',
    SM: 'sm',
    BASE: 'base',
    LG: 'lg',
    XL: 'xl',
    TWO_XL: '2xl',
    THREE_XL: '3xl',
    FOUR_XL: '4xl',
    FIVE_XL: '5xl',
    SIX_XL: '6xl',
    SEVEN_XL: '7xl',
    EIGHT_XL: '8xl',
    NINE_XL: '9xl'
  };

  const padding = {
    NONE: 'none',
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl'
  };

  return {
    variants,
    padding,
    colors,
    sizes
  };
}
